import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React from "react";
import { getStoreLocalData } from "../../utils/localStorage";

const PackageBookingPackageSelection = ({
  packageBookingModalVisible,
  setPackageBookingModalVisible,
  packageData,
  sendDataToBookNewOrderPage,
  status,
  text,
  storeCarryForward,
  brandCarryForward,  
}) => {

  const { storeLocalData } = getStoreLocalData();

  const selectedPackage = (item) => {
    // Close the modal
    sendDataToBookNewOrderPage({
      item,
    });
    setPackageBookingModalVisible(false);
  };

  const renderPackageData = () => {
    return packageData.map((item) => (
      <div
        onClick={() => selectedPackage(item)}
        style={{cursor:"pointer"}}
        className="flex flex-row border-bottom-1 justify-content-between align-items-center text-center"
      >
        <div style={{ flex: 0.2 }} className="mb-2">
          <img
            src={"Laundy_App_Icons_Gifs/Packages_GIFs/package1.gif"}
            style={{
              width: '50%',
              alignSelf: "center",
            }}
          />
        </div>
        <div className="flex-1">
          <div>
            <p className="text-xl font-medium">
              {item.name}
              {" - "}
              {item.description
                ? item.description
                : "Make laundry day a breeze with our exclusive Laundry Package."}
            </p>
          </div>
        </div>
         {brandCarryForward && storeCarryForward && item.carryForward && <div style={{
              borderRadius: "50px",
              backgroundImage:
                "radial-gradient(circle at left top, green, #fff)",
            }}>
            <p className="text-md font-medium p-2">
              CF
              </p>
        </div>}
        <div
          style={{
            flex: 0.2,
          }}
        >
          <p className="text-xl font-medium">{storeLocalData?.currencySymbol} {item.amount}</p>
        </div>
      </div>
    ));
  };

  const handleModalClose = () => {
    setPackageBookingModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={packageBookingModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!packageBookingModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column  gap-2"
            style={{
              borderRadius: "12px",
              backgroundImage:
                "radial-gradient(circle at left top, #fff, #fff)",
            }}
          >
            <div
              className="flex justify-content-between align-items-center gap-2 border-round-top"
              style={{
                
                backgroundImage:
                  "radial-gradient(circle at left top, #1752AA, #1752AA)",
              }}
            >
              <p></p>
              <p className=" text-3xl text-primary-50 font-semibold">
                Select Package
              </p>
              <div className="mx-4 my-2">
                <i
                  className="pi pi-times"
                  onClick={(e) => hide(e)}
                  style={{ fontSize: "25px", color: "red", cursor: "pointer" }}
                ></i>
              </div>
            </div>

            <div
              className="h-22rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
            <div className="py-4 px-4">
              <div>
                <div  >
                  <div>{renderPackageData()}</div>
                </div>
              </div>
            </div>
            </div>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default PackageBookingPackageSelection;
